module.exports = __webpack_public_path__ + "static/img/logo_Honda_3D.e76f332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icon/logo_Honda_3D.png
// module id = dM2k
// module chunks = 2